import { createFileRoute } from "@tanstack/react-router";
import { Contact } from "@/components/site/Contact";
import { Faq } from "@/components/site/Faq";
import { Gallery } from "@/components/site/Gallery";
import { Hero } from "@/components/site/Hero";
import { PriceMatch } from "@/components/site/PriceMatch";
import { Process } from "@/components/site/Process";
import { Reviews } from "@/components/site/Reviews";
import { Services } from "@/components/site/Services";
import { SiteShell } from "@/components/site/SiteShell";
import { StatsBand } from "@/components/site/StatsBand";
import { WhoWeServe } from "@/components/site/WhoWeServe";
import { WhySeaClay } from "@/components/site/WhySeaClay";
import { seo, SITE_TITLE, SITE_DESCRIPTION } from "@/lib/seo";
import { homeJsonLd } from "@/lib/structured-data";

const TITLE = SITE_TITLE;
const DESCRIPTION = SITE_DESCRIPTION;

export const Route = createFileRoute("/")({
  head: () => ({
    ...seo({ title: TITLE, description: DESCRIPTION, path: "/", home: true }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(homeJsonLd()),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <SiteShell>
      <Hero />
      <StatsBand />
      <Services />
      <PriceMatch />
      <WhySeaClay />
      <Gallery />
      <WhoWeServe />
      <Reviews />
      <Process />
      <Faq />
      <Contact />
    </SiteShell>
  );
}
